import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 76">
      <g>
        <path fill={colourFill} d="M27.81,39.94v3.8H31A3.61,3.61,0,0,0,27.81,39.94Z" />
        <path fill={colourFill} d="M19.41,46.33v1.29c0,.45.26,1.94,2.59,1.94h6.45c2.33,0,2.59-1.49,2.59-1.94V46.33Z" />
        <path
          fill={colourFill}
          d="M46.47,19.27a1.88,1.88,0,0,0-.58-1.61L33.1,5.39A1.25,1.25,0,0,0,32.2,5H10.37c-5.1,0-6.45,4.2-6.45,6.46V63.12c0,2.26,1.35,6.45,6.45,6.45H40.08c5.1,0,6.45-4.19,6.45-6.45Zm-30.93.58h11v2.59h-11ZM30.39,58.6a4.5,4.5,0,0,1-4.52-4.52,4.89,4.89,0,0,1,.45-1.94H24.13a4.73,4.73,0,0,1,.45,1.94,4.52,4.52,0,1,1-9,0,4.59,4.59,0,0,1,2.19-3.88,4.57,4.57,0,0,1-.9-2.58V43.74c0-.64-.45-.64-.65-.64h-.64V40.52h.64a3.12,3.12,0,0,1,3.23,3.22h5.82V37.29h1.93a6.2,6.2,0,0,1,6.46,6.39h.07V45l.06,1.29h-.06v1.36a4.6,4.6,0,0,1-.91,2.58A4.53,4.53,0,0,1,35,54.08,4.6,4.6,0,0,1,30.39,58.6Zm4.52-25.19H15.54V30.83H34.91Zm0-4.52H15.54V26.31H34.91Zm3.23-11.62c-4.33,0-4.52-3.49-4.52-3.88V9.45l8.14,7.82Z"
        />
        <path fill={colourFill} d="M32.33,54.08a1.94,1.94,0,0,1-3.88,0,1.94,1.94,0,1,1,3.88,0" />
        <path fill={colourFill} d="M22,54.08a1.94,1.94,0,0,1-3.88,0,1.94,1.94,0,1,1,3.88,0" />
      </g>
    </svg>
  );
};

export default ServiceIcon;
